<template>
  <!-- Dialog - Route View -->
  <v-dialog
    v-model="dialog"
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-toolbar>
      <v-toolbar-title>{{ $t("newLaunch") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-card>
      <div>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <div class="px-6 py-4 grey--text">
              <div>{{ $t("to") }}: {{ $route.query.name_collector }}</div>
              <!-- <div>Balanço: {{ $route.query.balance }}</div> -->
            </div>
            <v-divider></v-divider>
            <div class="ma-4">
              <v-row>
                <v-col cols="4">
                  <div class="pa-4 text-right">{{ $t("categoryLabel") }}:</div>
                </v-col>
                <v-col cols="8">
                  <v-select
                    v-model="selectCategory"
                    :items="categorys"
                    solo-inverted
                    placeholder="Selecione uma Categoria"
                    item-text="nome"
                    item-value="id"
                    return-object
                    dense
                    class="mr-4 mt-2"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <div class="pa-4 text-right">{{ $t("valueLabel") }}:</div>
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    :label="$t('valueLabel')"
                    v-model="valueEntry"
                    :rules="valueEntryRules"
                    required
                    clearable
                    outlined
                    type="number"
                    :prefix="this.$t('labelCurrency')"
                    dense
                    class="mr-4 mt-2"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <div class="pa-4 text-right">{{ $t("description") }}:</div>
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="description"
                    required
                    clearable
                    outlined
                    dense
                    counter="80"
                    class="mr-4 mt-2"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                :loading="loading"
                v-on:click.prevent="setCash"
                type="submit"
                :disabled="!valid"
              >
                {{ $t("btnSave") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "regional-manager-financial-regional-set-cash",
  data: () => ({
    valid: false,

    selectCategory: "",
    valueEntry: "",
    description: "",
    loading: false,
  }),
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
    categorys() {
      return [
        { id: "2", nome: this.$t("prizeDepositPayment") },
        { id: "3", nome: this.$t("miscellaneouDeposit") },
        { id: "4", nome: this.$t("chargeback") },
      ];
    },
    valueEntryRules() {
      return [(v) => !!v || this.$t("rulesPassMatch")];
    },

  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    setCash: async function() {
      if (!this.$refs.form.validate()) {
        return;
      }

      // Validation description
      var descriptionLength =
        this.description != null ? this.description.length : 0;
      if (descriptionLength > 80) {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("msgFeedBackSetCash"),
          color: "warning",
        });
        return;
      }

      this.$store.commit("setFeedbackProgress", true);
      this.loading = true;

      const body = {
        id_collector: this.$route.params.id_collector,
        value: this.valueEntry,
        category: this.selectCategory.id,
        description: this.description,
      };
      try {
        const result = await this.$request.post(
          "regionalManager/financial/setCash",
          body
        );
        this.$store.commit("setFeedbackSnack", {
          msg: result.messages,
          color: "success",
        });
        this.$refs.form.reset();
        this.$store.commit("showDialog", false);
        this.$store.commit("setRefresh", true);
      } finally {
        this.loading = false;
      }
    },
    // Close Dialog
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
  },
};
</script>
